import { axios, toQueryString} from '.'
import { useQuery, useMutation, UseQueryOptions } from '@tanstack/react-query'
import { GetStParams, StBreak, StDetection, StObject, StSpeed } from '../types'

const getQueryData = ({partName, groupName, driveNumber, startDate, endDate}: GetStParams) => {
  try {
    const paths = [partName]
    if (!partName || !startDate || !endDate) throw new Error() 

    if (groupName) {
      paths.push(groupName)
      if (driveNumber) paths.push(driveNumber)
    }

    return {
      endpoint: `/${paths.join("/")}?start=${startDate}&end=${endDate}`,
      enabled: true
    }
  } catch (e: any) {
    return {endpoint: "", enabled: false}
  }
}

export const useUpdateSt = () => {
  return useMutation({
    mutationFn: (driveNumber: string) => axios.main.post(`st/adas/${driveNumber}`)
  })
}

export const useGetStSpeed = (data: GetStParams, options?: object) => {
  const {enabled, endpoint} = getQueryData(data)

  return useQuery<StSpeed>({
    queryKey: ["useGetStSpeed", data],
    queryFn: () => axios.main.get("st/speed" + endpoint).then(res => res.data),
    ...options,
    enabled,
    staleTime: 0,
    gcTime: 0,
  })
}

export const useGetStBreak = (data: GetStParams, options?: object) => {
  const {enabled, endpoint} = getQueryData(data)

  return useQuery<StBreak>({
    queryKey: ["useGetStBreak", data],
    queryFn: () => axios.main.get("v2/st/break" + endpoint).then(res => res.data),
    ...options,
    enabled,
    staleTime: 0,
    gcTime: 0,
  })
}

export const useGetStObject = (data: GetStParams, options?: object) => {
  const {enabled, endpoint} = getQueryData(data)

  return useQuery<StObject>({
    queryKey: ["useGetStObject", data],
    queryFn: () => axios.main.get("st/object" + endpoint).then(res => res.data),
    ...options,
    enabled,
    staleTime: 0,
    gcTime: 0,
  })
}

export const useGetStDetection = (data: GetStParams, options?: object) => {
  const {enabled, endpoint} = getQueryData(data)

  return useQuery<StDetection[]>({
    queryKey: ["useGetStDetection", data],
    queryFn: () => axios.main.get("st/objects/speed" + endpoint).then(res => res.data),
    ...options,
    enabled,
    staleTime: 0,
    gcTime: 0,
  })
}

export const useGetStSigLdws = (data: GetStParams, options?: object) => {
  const {enabled, endpoint} = getQueryData(data)

  return useQuery({
    queryKey: ["useGetStSigLdws", data],
    queryFn: () => axios.main.get("st/sig/ldws" + endpoint).then(res => res.data),
    ...options,
    enabled,
    staleTime: 0,
    gcTime: 0,
  })
}

export const useGetStSigBreak = (data: GetStParams, options?: object) => {
  const {enabled, endpoint} = getQueryData(data)

  return useQuery({
    queryKey: ["useGetStSigBreak", data],
    queryFn: () => axios.main.get("st/sig/break" + endpoint).then(res => res.data),
    ...options,
    enabled,
    staleTime: 0,
    gcTime: 0,
  })
}